import { action } from 'satcheljs';
import DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';

export const displayDensityOptionSelected = action(
    'DISPLAY_DENSITY_OPTION_SELECTED',
    (newDensityModeSelected: DisplayDensityMode) => ({
        newDensityModeSelected: newDensityModeSelected,
    })
);

export const discardDensityOption = action('DISCARD_DENSITY_OPTION');
